
<template>
    <div>
        <van-nav-bar
                title="Información bancaria"
                left-text=""
                right-text=""
                left-arrow
                @click-left="onClickLeft"
                @click-right="onClickRight"
        >
            <template #left>
                <van-icon name="arrow-left" color="#000000" />
                <span>Volver</span>
            </template>
        </van-nav-bar>
        <div id="applybank">
            <div class="apply_wrap">
                <div class="apply_banner">
                    <!--<img src="../../assets/img/applyhead.png" />-->
                </div>
                <div class="apply_head">
                    <div class="apply_hview">
                        <img src="../../assets/img/applyhead05.webp" />
                    </div>
                </div>

                <div class="apply_topview">
                    <div class="apply_top">
                        Ya desbloqueó el monto. Rellene información para aumenterlo.
                    </div>
                </div>
                <div class="apply_formview">

                    <div class="bank_conttop">
                        <div class="bank_ctitems" @click="onCheckitem('1')">
                            <div class="bank_ctitem" :class="isCheck == '1' ? 'bank_ctitem_active' : ''">
                                <div class="bank_ctileft">
                                    <template v-if="bankoneval == null">
                                        Elija el tipo de cuenta
                                    </template>
                                    <template v-else>
                                        {{bankoneval.name}}
                                    </template>
                                </div>
                                <div class="bank_ctiright">
                                    <div class="bank_ctirview"><img src="../../assets/img/comf_rparrow.png" alt=""></div>
                                </div>
                            </div>
                        </div>


                        <div class="bank_ctitems" @click="onCheckitem('2')">
                            <div class="bank_ctitem" :class="isCheck == '2' ? 'bank_ctitem_active' : ''">
                                <div class="bank_ctileft">
                                    <template v-if="banktwoval == null">
                                        Nombre de banco
                                    </template>
                                    <template v-else>
                                        {{ banktwoval.rpm_ydl_iiq }}
                                    </template>
                                </div>
                                <div class="bank_ctiright">
                                    <div class="bank_ctirview"><img src="../../assets/img/comf_rparrow.png" alt=""></div>
                                </div>
                            </div>
                        </div>

                        <div class="bank_ctitems" @click="onCheckitem('3')">
                            <div class="bank_ctitem" :class="isCheck == '3' ? 'bank_ctitem_active' : ''">
                                <van-field
                                        v-model="bank_no"
                                        label=""
                                        type="number"
                                        placeholder="Rellene el número de tarjeta bancaria"
                                        :clearable="isTrue"
                                        :maxlength="maxLen"
                                />
                            </div>
                        </div>
                    </div>

                    <div class="bank_contmiddle">
                        <div class="bank_contmleft">
                            <div class="bank_contmlview">
                                <img src="../../assets/img/apply_useicon.png" />
                            </div>
                        </div>
                        <div class="bank_contmright">
                            <p>
                                Superapoyomax mantiene su información personal privada y segura durante todo el proceso.
                            </p>
                        </div>
                    </div>


                    <div class="bank_contdown">
                        <van-button round color="#19A95C" block style="height: 1.111111rem;" @click.stop="onConfirm">
                            <span style="font-weight: 500;">Enviar</span>
                        </van-button>
                    </div>

                </div>
            </div>


            <van-action-sheet
                    v-model="bankoneShow"
                    :actions="actionsOne"
                    cancel-text="Cancelar"
                    description="Nivel de su ingreso"
                    close-on-click-action
                    @select="onSelectOne"
            >
            </van-action-sheet>

            <template v-show="bank_list && bank_list.length > 0">
                <van-popup v-model="banktwoShow" position="right" :style="{ height: '100vh', width: '90vw'}">
                    <div class="zhou_wrap">
                        <van-index-bar @change="onBarChange" :index-list="bankIndexArr">
                            <template v-for="(item) in bank_list">
                                <van-index-anchor :index="item.title" :key="item.title"></van-index-anchor>
                                <template v-for="(chitem) in item.items">
                                    <van-cell :title="chitem.rpm_ydl_iiq" :key="chitem.jlb_rnb_wmb" @click.stop="onSelectBank(chitem)"></van-cell>
                                </template>
                            </template>

                        </van-index-bar>
                    </div>
                </van-popup>
            </template>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    import { getTimezoneName, getUserIp } from '@/utils/commonParams';
    import { loadingShow, loadingHide } from '@/utils/loading'
    import { getAccessToken } from '@/utils/auth';

    import { getAccountInfo, getBankList, updateBankCard } from '@/api/apply'
    import { getLoanInfo, retryLoan } from '@/api/loan'

    import { Toast } from 'vant';
    import $ from 'jquery';

    export default{
        data() {
            return {
                activeNav: 'living',
                isCheck: '1',
                isTrue: true,
                bankoneShow: false,
                bankoneval: null,
                actionsOne: [
                    { id: '1', name: 'CLABE'},
                    { id: '2', name: 'Tarjeta de débito' },
                    { id: '1', name: 'Spin Clabe' },
                ],
                banktwoShow: false,
                banktwoval: null,
                bank_no: null,
                bankmessage: null,
                bankIndexArr: [],
                bank_list: [],
                maxLen: 18,
            }
        },
        mounted() {
            this.accountInfo();
        },
        methods: {
            onClickLeft() {
                this.$router.back();
            },
            onClickRight() {

            },
            getQueryString(name) {
                var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
                var r = window.location.search.substr(1).match(reg);
                if (r != null) {
                    return unescape(r[2]);
                }
                return null;
            },
            onSelectOne(item) {
                console.log(item)
                this.bankoneval = item;
                loadingShow();
                this.getCommomParams('password');
                if(item.id == '1'){
                    this.maxLen = 18;
                } else if(item.id == '2'){
                    this.maxLen = 16;
                }
                this.bank_no = null;
            },
            onCheckitem(type){
                console.log(type)
                this.isCheck = type;
                if(type == '1'){
                    this.bankoneShow = true;
                    this.banktwoShow = false;
                } else if(type == '2'){
                    this.bankoneShow = false;
                    if(this.bankoneval && this.bankoneval.id){
                        this.banktwoShow = true;
                    } else {
                        Toast('请先选择银行类型')
                    }
                }
            },
            onBarChange(index) {
                setTimeout(() => {
                    $('.van-index-anchor').css({
                        left: 0,
                        width: '90vw'
                    })
                }, 50);
            },
            onSelectBank(item){
                console.log(item)
                this.banktwoShow = false;
                this.banktwoval = item;
            },
            pySegSort(array) {
                let map = {};
                let indexArr = [];
                let newArr = [];
                for(let i = 0; i < 26; i++){
                    const key = String.fromCharCode(65 + i) //A-Z赋给key当作键
                    map[key] = {
                        title: key,
                        items: []
                    };
                    array.map((v,k)=>{      //遍历数组
                        console.log(v)
                        let firstIndex = v.rpm_ydl_iiq.charAt(0).toUpperCase();//首字母
                        if(firstIndex.toUpperCase() == String.fromCharCode(65+i)){//统一转成大写进行逐个判断
                            map[key].items.push(v)//push进相对应的数组里头
                        }
                    })
                    // //如果当前的数组里头为空，则跳过。
                    if(map[key].items === undefined || map[key].items.length == 0){
                        continue;
                    }else{
                        indexArr.push(key)
                        newArr.push(map[key])//将分类好的每个对象 合并在一个数组里面
                    }
                }

                this.bankIndexArr = indexArr;

                //loadingHide()

                return newArr;

            },
            async accountInfo() {
                console.log('前往登录')
                const login_token = getAccessToken();
                console.log(login_token)
                if(login_token){ //已经登录
                    console.log('已登录11111')
                    let time_zone = getTimezoneName();
                    console.log(time_zone);
                    loadingShow();
                    let ip = await getUserIp()
                    console.log(ip)

                    let postData = {
                        zzm_yya_hqb: getAccessToken(),
                        aaa_off_csl: '111',
                    };

                    let headerParams = {
                        'ad-justad-id': localStorage.getItem("adjust_id"),
                        'ad-justad-j': '',
                        'ad-justad-idfv': '',
                    };

                    loadingShow();
                    getAccountInfo(postData, {
                        'bwd-irh-lnf': time_zone,
                        'xfo-plp-van': ip,
                        ...headerParams
                    }).then(res => {
                        console.log(res)
                        loadingHide()
                        if(res.ci == 200){
                            let useData = res.da;
                            console.log(JSON.parse(useData))
                            if(useData){
                                let useDataJSON = JSON.parse(useData);
                                let { bqr_rle_jto, wva_cld_loe } = useDataJSON;

                                if(wva_cld_loe){
                                    let { eoq_luw_epg } = wva_cld_loe;
                                    if(eoq_luw_epg) {
                                        let { yuu_xtj_tcx, hxo_gjz_xif } = eoq_luw_epg;
                                    }
                                }
                            }
                        } else {
                            Toast(res.ms);
                        }
                    }, error => {
                        loadingHide()
                    });


                } else { //未登录
                    console.log('未登录1111')
                    this.$router.replace({
                        path: '/loanpage/loginhome'
                    })
                    //this.gotoLogin();
                }
            },
            async getCommomParams(type) {
                let time_zone = getTimezoneName();
                console.log(time_zone);
                loadingShow();
                let ip = await getUserIp()
                console.log(ip)

                if(type == 'password'){
                    let commonParams = this.setCommonParams(time_zone, ip)
                } else if(type == 'info'){
                    let commonParams = this.infoCommonParams(time_zone, ip)
                }
            },
            setCommonParams(time_zone, ip){
                let access_token = getAccessToken();

                let _this = this;

                let postData = {
                    zzm_yya_hqb: access_token,
                    rhb_kbf_nxf: _this.bankoneval.id,
                    aaa_off_csl: '111',
                };

                let headerParams = {
                    'ad-justad-id': localStorage.getItem("adjust_id"),
                    'ad-justad-j': '',
                    'ad-justad-idfv': '',
                };

                loadingShow();
                getBankList(postData, {
                    'bwd-irh-lnf': time_zone,
                    'xfo-plp-van': ip,
                    ...headerParams
                }).then(res => {
                    console.log(res)
                    loadingHide()
                    if (res.ci == 200) {
                        this.bank_list = [];
                        let useData = res.da;
                        console.log(JSON.parse(useData))
                        let { xkk_ypr_qiw } = JSON.parse(useData);
                        let bank_list = xkk_ypr_qiw;

                        if(bank_list && bank_list.length){
                            let usebank_list = this.pySegSort(bank_list);
                            this.bank_list = usebank_list;
                        }
                    } else {
                        Toast(res.ms);
                    }
                }, error => {
                    loadingHide()
                });
            },
            infoCommonParams(time_zone, ip){
                let access_token = getAccessToken();
                let _this = this;

                let postData = {
                    zzm_yya_hqb: access_token,
                    swy_mpx_hmo: _this.bankoneval.id,
                    yuu_xtj_tcx: _this.banktwoval.rpm_ydl_iiq,
                    hxo_gjz_xif: _this.bank_no,
                    aaa_off_csl: '111',
                    itv_iyf_bdc: "",
                    nen_cog_yim: "",
                };

                console.log(postData)

                let headerParams = {
                    'ad-justad-id': localStorage.getItem("adjust_id"),
                    'ad-justad-j': '',
                    'ad-justad-idfv': '',
                };

                loadingShow();
                updateBankCard(postData, {
                    'bwd-irh-lnf': time_zone,
                    'xfo-plp-van': ip,
                    ...headerParams
                }).then(res => {
                    if (res.ci == 200) {
                        let useData = res.da;
                        console.log(JSON.parse(useData))
                        if (useData) {
                            let useDataJSON = JSON.parse(useData);
                            let { bqr_rle_jto } = useDataJSON;

                            let isreject = this.getQueryString('isreject');

                            if(isreject && isreject == 1){
                                this.onRetryLoan(time_zone, ip, bqr_rle_jto);
                            } else {
                                if(bqr_rle_jto == 8001){
                                    loadingHide()
                                    this.$router.replace({
                                        path: '/loanpage/applywork'
                                    })
                                } else if(bqr_rle_jto == 8002){
                                    loadingHide()
                                    this.$router.replace({
                                        path: '/loanpage/applycontacts'
                                    })
                                } else if(bqr_rle_jto == 8004){
                                    loadingHide()
                                    this.$router.replace({
                                        path: '/loanpage/applyperson'
                                    })
                                } else if(bqr_rle_jto == 8005){
                                    loadingHide()
                                    this.$router.replace({
                                        path: '/loanpage/applyidcard'
                                    })
                                } else if(bqr_rle_jto == 8006){
                                    loadingHide()
                                    this.$router.replace({
                                        path: '/loanpage/livingverify'
                                    })
                                } else if(bqr_rle_jto == 7106){
                                    loadingHide()
                                    this.$router.replace({
                                        path: '/loanpage/livingverify'
                                    })
                                } else if(bqr_rle_jto == 8010){
                                    loadingHide()
                                    this.$router.replace({
                                        path: '/loanpage/applybank'
                                    })
                                } else if(bqr_rle_jto == 7101){
                                    this.gotoStatus();
                                    // this.$router.replace({
                                    //     path: '/loanpage/applyhome'
                                    // })
                                } else if(bqr_rle_jto == 7102){
                                    this.gotoStatus();
                                    // this.$router.replace({
                                    //     path: '/loanpage/applyhome'
                                    // })
                                } else if(bqr_rle_jto == 7105){
                                    this.gotoStatus();
                                    // this.$router.replace({
                                    //     path: '/loanpage/applyhome'
                                    // })
                                } else if(bqr_rle_jto == 8110){
                                    this.gotoStatus();
                                    // this.$router.replace({
                                    //     path: '/loanpage/applyhome'
                                    // })
                                }
                            }
                        }
                    } else {
                        loadingHide()
                        Toast(res.ms);
                    }
                }, error => {
                    loadingHide()
                });
            },
            onRetryLoan(time_zone, ip, bqr_rle_jto){
                let access_token = getAccessToken();
                let _this = this;

                let postData = {
                    zzm_yya_hqb: access_token,
                    swy_mpx_hmo: _this.bankoneval.id,
                    yuu_xtj_tcx: _this.banktwoval.rpm_ydl_iiq,
                    hxo_gjz_xif: _this.bank_no,
                    aaa_off_csl: '111',
                    itv_iyf_bdc: "",
                    nen_cog_yim: "",
                };

                let headerParams = {
                    'ad-justad-id': localStorage.getItem("adjust_id"),
                    'ad-justad-j': '',
                    'ad-justad-idfv': '',
                };

                retryLoan(postData, {
                    'bwd-irh-lnf': time_zone,
                    'xfo-plp-van': ip,
                    ...headerParams
                }).then(res => {
                    if (res.ci == 200) {

                        this.gotoStatus();

                        /*if(bqr_rle_jto == 8001){
                            loadingHide()
                            this.$router.replace({
                                path: '/loanpage/applywork'
                            })
                        } else if(bqr_rle_jto == 8002){
                            loadingHide()
                            this.$router.replace({
                                path: '/loanpage/applycontacts'
                            })
                        } else if(bqr_rle_jto == 8004){
                            loadingHide()
                            this.$router.replace({
                                path: '/loanpage/applyperson'
                            })
                        } else if(bqr_rle_jto == 8005){
                            loadingHide()
                            this.$router.replace({
                                path: '/loanpage/applyidcard'
                            })
                        } else if(bqr_rle_jto == 8006){
                            loadingHide()
                            this.$router.replace({
                                path: '/loanpage/livingverify'
                            })
                        } else if(bqr_rle_jto == 7106){
                            loadingHide()
                            this.$router.replace({
                                path: '/loanpage/livingverify'
                            })
                        } else if(bqr_rle_jto == 8010){
                            loadingHide()
                            this.$router.replace({
                                path: '/loanpage/applybank'
                            })
                        } else if(bqr_rle_jto == 7101){
                            this.gotoStatus();
                            // this.$router.replace({
                            //     path: '/loanpage/applyhome'
                            // })
                        } else if(bqr_rle_jto == 7102){
                            this.gotoStatus();
                            // this.$router.replace({
                            //     path: '/loanpage/applyhome'
                            // })
                        } else if(bqr_rle_jto == 7105){
                            this.gotoStatus();
                            // this.$router.replace({
                            //     path: '/loanpage/applyhome'
                            // })
                        } else if(bqr_rle_jto == 8110){
                            this.gotoStatus();
                            // this.$router.replace({
                            //     path: '/loanpage/applyhome'
                            // })
                        }*/

                    } else {
                        loadingHide()
                        Toast(res.ms);
                    }
                }, error => {
                    loadingHide()
                })
            },
            async gotoStatus() {
                let _this = this;
                const login_token = getAccessToken();
                console.log(login_token)
                if(login_token){ //已经登录
                    console.log('已登录11111')
                    let time_zone = getTimezoneName();
                    console.log(time_zone);
                    loadingShow();
                    let ip = await getUserIp()
                    console.log(ip)

                    let postData = {
                        zzm_yya_hqb: getAccessToken(),
                        aaa_off_csl: '111',
                    };

                    let headerParams = {
                        'ad-justad-id': localStorage.getItem("adjust_id"),
                        'ad-justad-j': '',
                        'ad-justad-idfv': '',
                    };

                    loadingShow();
                    getLoanInfo(postData, {
                        'bwd-irh-lnf': time_zone,
                        'xfo-plp-van': ip,
                        ...headerParams
                    }).then(res => {
                        console.log(res)
                        loadingHide()
                        this.isInfoLoading = false;
                        if(res.ci == 200){
                            let useData = res.da;
                            console.log(JSON.parse(useData))
                            if(useData){
                                let useDataJSON = JSON.parse(useData);
                                let {vkt_fnd_yzo, ojq_dzg_oxq } = useDataJSON;
                                //order_status, reapply_time, server_time current_is_reloan,
                                let { omi_fje_qly, huw_kdq_nxo, xhi_cur_ovl } = vkt_fnd_yzo;

                                console.log(omi_fje_qly);
                                console.log(huw_kdq_nxo);
                                console.log(ojq_dzg_oxq);
                                console.log(xhi_cur_ovl);

                                this.orderStatusNor = omi_fje_qly;
                                this.getStatus(omi_fje_qly, huw_kdq_nxo,  ojq_dzg_oxq, xhi_cur_ovl, _this);

                            }
                        } else {
                            Toast(res.ms);
                        }
                    }, error => {
                        loadingHide()
                        this.isInfoLoading = false;
                    });
                } else { //未登录
                    console.log('未登录1111')
                    this.$router.replace({
                        path: '/loanpage/loginhome'
                    })

                }
            },
            getStatus: (value, reapply_time, server_time, current_is_reloan, _this) => {
                switch (value) {
                    case 0:
                    case 10:
                    case 15:
                    case 17:
                    case 21:
                        console.log('0没有申请过,10失效,15展期结清,17展期失效,21等待签约');
                        _this.orderStatus = 2;
                        if(current_is_reloan != undefined){
                            if(current_is_reloan == 1){
                                _this.isReloan = 1;
                            } else {
                                _this.isReloan = null;
                            }
                        } else {
                            _this.isReloan = null;
                        }

                        if(_this.isReloan == 1){
                            _this.$router.replace({
                                path: '/loanpage/reapeatloan'
                            });
                        } else {
                            _this.$router.replace({
                                path: '/loanpage/applyhome'
                            });
                        }
                        break;
                    case 1:
                    case 2:
                    case 4:
                    case 13:
                    case 18:
                    case 19:
                    case 20:
                        console.log('//1提交申请,2提交审核,4等待人工审核,13等待第三方黑名单验证,18等待自动外呼,19等待人脸对比,20人工审核质检中');
                        _this.orderStatus = 1;
                        _this.loanStatus = 1;
                        _this.$router.replace({
                            path: '/loanpage/loanstatus'
                        });
                        break;
                    case 3:
                        console.log('//审核拒绝');
                        if (_this.canReloanByTime(reapply_time, server_time)) {
                            _this.orderStatus = 2;
                            /*if (_this.isReloan) {
                                if(current_is_reloan != undefined){
                                    if(current_is_reloan == 1){
                                        _this.isReloan = 1;
                                    } else {
                                        _this.isReloan = 1;
                                    }
                                } else {
                                    _this.isReloan = 1;
                                }
                                _this.$router.replace({
                                    path: '/loanpage/reapeatloan'
                                });
                            } else {

                            }*/

                            if(current_is_reloan != undefined){
                                if(current_is_reloan == 1){
                                    _this.isReloan = 1;
                                } else {
                                    _this.isReloan = null;
                                }
                            } else {
                                _this.isReloan = null;
                            }

                            if(_this.isReloan == 1){
                                _this.$router.replace({
                                    path: '/loanpage/reapeatloan'
                                });
                            } else {
                                _this.$router.replace({
                                    path: '/loanpage/applyhome'
                                });
                            }
                        } else {
                            _this.orderStatus = 1;
                            _this.loanStatus = 2;

                            _this.$router.replace({
                                path: '/loanpage/loanstatus'
                            });
                        }
                        break;
                    case 5:
                    case 12:
                        console.log('//5等待放款，12正在放款中');
                        _this.orderStatus = 1;
                        _this.loanStatus = 3;

                        _this.$router.replace({
                            path: '/loanpage/loanstatus'
                        });
                        break;
                    case 6:
                        console.log('//放款失败');
                        _this.orderStatus = 1;
                        _this.loanStatus = 4;

                        _this.$router.replace({
                            path: '/loanpage/loanstatus'
                        });
                        break;
                    case 7:
                    case 9:
                    case 11:
                    case 14:
                    case 16:
                        console.log('7等待还款，9逾期，11部分还款，14等待展期，16展期申请中');
                        _this.orderStatus = 3;

                        _this.$router.replace({
                            path: '/loanpage/repayment'
                        });
                        break;
                    case 8:
                        console.log('8已结清');
                        _this.orderStatus = 2;
                        if(current_is_reloan != undefined){
                            if(current_is_reloan == 1){
                                _this.isReloan = 1;
                            } else {
                                _this.isReloan = 1;
                            }
                        } else {
                            _this.isReloan = 1;
                        }
                        _this.$router.replace({
                            path: '/loanpage/reapeatloan'
                        });
                        break;
                    case 22:
                        console.log('22等待订单再次确认');
                        _this.orderStatus = 2;
                        if(current_is_reloan != undefined){
                            if(current_is_reloan == 1){
                                _this.isReloan = 1;
                            } else {
                                _this.isReloan = 0;
                            }
                        } else {
                            _this.isReloan = 0;
                        }

                        _this.$router.replace({
                            path: '/loanpage/firstloan'
                        });
                        break;
                    default:
                        _this.orderStatus = 2;
                        if(current_is_reloan != undefined){
                            if(current_is_reloan == 1){
                                _this.isReloan = 1;
                            } else {
                                _this.isReloan = null;
                            }
                        } else {
                            _this.isReloan = null;
                        }

                        if(_this.isReloan == 1){
                            _this.$router.replace({
                                path: '/loanpage/reapeatloan'
                            });
                        } else {
                            _this.$router.replace({
                                path: '/loanpage/applyhome'
                            });
                        }
                }
            },
            canReloanByTime(repTime, stime) {
                return repTime < stime;
            },
            onConfirm() {
                let bankoneval = this.bankoneval;
                let banktwoval = this.banktwoval;

                let bank_no = this.bank_no;

                if(bankoneval && bankoneval.id){
                    if(banktwoval && banktwoval.jlb_rnb_wmb){
                        if(bank_no && bank_no.length) {

                            if(bankoneval.id == 1){
                                if(bank_no.length == 18){
                                    this.getCommomParams('info');
                                } else {
                                    Toast('Cuenta bancaria tiene 18 dígitos') //银行卡号为18位
                                }

                            } else if(bankoneval.id == 2){

                                if(bank_no.length == 16){
                                    this.getCommomParams('info');
                                } else {
                                    Toast('Cuenta bancaria tiene 16 dígitos') //银行卡号为16位
                                }
                            }

                        } else {
                            Toast('Ingresa número de cuenta bancaria') //请填写银行卡号
                        }
                    } else {
                        Toast('Elige banco') //请选择银行
                    }
                } else {
                    Toast('Elige tipo de banco') //请选择银行类型
                }
            },
        }
    }
</script>

<style less scoped>
    .apply_banner{
        width: 100%;
        height: 1.45rem;
        box-sizing: border-box;
        padding: 0.25rem 0.277778rem 0 0.277778rem;
        position: relative;
    }
    .apply_head{
        width: 100%;
        height: 0.75rem;
        position: relative;
    }
    .apply_hview{
        width: 8.944444rem;
        height: 0.555556rem;
        position: absolute;
        left: 0.56rem;
        top: -0.611111rem;
    }
    .apply_hview img{
        display: block;
        width: 8.944444rem;
        height: 0.555556rem;
    }
    .apply_topview{
        width: 100%;
        height: 2.055556rem;
        box-sizing: border-box;
        padding: 0 0.555556rem;
    }
    .apply_top{
        width: 100%;
        height: 1.555556rem;
        box-sizing: border-box;
        padding: 0 0.5rem;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #DDF2E7;
        border-radius: 0.111111rem;
        font-size: 12px;
        font-weight: 400;
        color: #666666;
        line-height: 0.5rem;
    }
    .apply_formview{
        width: 100%;
        height: auto;
        box-sizing: border-box;
        padding: 0 0.555556rem;
    }
    .bank_conttop{
        width: 100%;
        height: auto;
    }
    .bank_ctitems{
        width: 100%;
        height: 1.472222rem;
    }
    .bank_ctitem{
        width: 100%;
        height: 1.111111rem;
        box-sizing: border-box;
        background: #ffffff;
        border-radius: 0.083333rem;
        border: 1px solid #DEE0E6;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .bank_ctitem_active{
        border: 1px solid #00CA88;
    }
    .bank_ctileft{
        width: auto;
        height: 14px;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        padding-left: 0.444444rem;
        font-size: 13px;
        font-weight: 500;
        color: #1A1A1A;
    }
    .bank_ctiright{
        width: auto;
        height: 8px;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        padding-right: 0.416667rem;
    }
    .bank_ctirview{
        width: 13px;
        height: 8px;
    }
    .bank_ctirview img{
        display: block;
        width: 13px;
        height: 8px;
    }
    .bank_ctitem_active .bank_ctileft{
        color: #1A1A1A;
    }
    .bank_ctitem .bank_code{
        display: block;
        width: 90%;
        height: 0.8rem;
        outline: none;
        border: none;
        background: #ffffff;
        border-radius: 0.333333rem;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        padding-left: 0.444444rem;
        font-size: 13px;
        font-weight: 500;
        color: #1A1A1A;
    }
    .bank_ctitem_active .bank_code{
        color: #1A1A1A;
    }
    .bank_contmiddle{
        width: 100%;
        height: 1.611111rem;
        display: flex;
        justify-content: flex-start;
    }
    .bank_contmleft{
        width: 0.666667rem;
        height: 0.444444rem;
    }
    .bank_contmlview{
        width: 0.394444rem;
        height: 0.444444rem;
        margin-top: 2px;
    }
    .bank_contmlview img{
        display: block;
        width: 0.394444rem;
        height: 0.444444rem;
    }
    .bank_contmright{
        width: 7.888889rem;
        height: 1.0rem;
        display: flex;
        align-items: center;
    }
    .bank_contmright p{
        font-size: 0.333333rem;
        font-weight: 500;
        color: #999999;
    }
    .bank_contdown{
        width: 7.722222rem;
        height: 1.111111rem;
        margin: 0 auto;
    }
    .zhou_wrap{
        width: 90vw;
        height: 100vh;
        overflow-y: auto;
        overflow-x: hidden;
    }
</style>

<style less>
    #applybank .van-action-sheet__description{
        background: #19A95C;
        color: #ffffff;
        font-size: 16px;
    }
    #applybank .van-action-sheet__cancel{
        color: #FB4840;
    }
    #applybank .van-action-sheet__item .van-action-sheet__name{
        color: #19A95C;
    }
    #applybank .van-cell{
        padding: 4px 0.444444rem 4px 0.416667rem;
    }
    #applybank .van-index-bar__index{
        padding: 4px 8px 4px 16px;
    }
    #applybank .van-dialog{
        width: 76.39vw;
        border-radius: 0.277778rem;
    }
    #applybank .van-dialog__confirm, .van-dialog__confirm:active{
        background: #19A95C;
    }
</style>